import { Tc, PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';

export class MunicipioItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: MunicipioViewModel[];
}
export class MunicipioViewModel {
    constructor() {}

    public Id: number;
    public IdProvincia: number;
    public IdProvinciaDescripcion: string = '';
    public Descripcion: string = '';
    public DescripcionTraces: string = '';
    public MunicipioSigpac: number | null;
    public Activo: number = EnumSiNoTodos.SI;
}

export class FilterSearchingMunicipioViewModel extends FilterSearchingBaseViewModel {
    public IdProvincia: number | null;
    public Descripcion: string = '';
    public DescripcionTraces: string = '';
    public Activo: number = EnumSiNoTodos.SI;
}
